import script from "./GlassLoaderForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GlassLoaderForm.vue?vue&type=script&setup=true&lang=js"

import "./GlassLoaderForm.vue?vue&type=style&index=0&id=fbfec46a&lang=css"

const __exports__ = script;

export default __exports__